import React, { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Outlet, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuth } from "provider/AuthContext";
import Appbar from "../Appbar";
import AppHeader from "../AppHeader";
import AppFooter from "../AppFooter";
import Login from "pages/auth/LoginPage";
import Register from "pages/auth/RegisterPage";
import Cookies from "js-cookie";

const AppLayout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [childLinks, setChildLinks] = useState([]);

  const isSportsbookPage = location.pathname.startsWith("/sportsbook/");
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng.value);
    Cookies.set("lang", lng.value, { path: "/", expires: 365 });
  };

  const [matchesMedia, setMatchesMedia] = useState({
    isMobile: window?.innerWidth <= 1024,
    isTablet: window?.innerWidth <= 768,
  });

  useEffect(() => {
    const handleResize = () => {
      setMatchesMedia({
        isMobile: window?.innerWidth <= 1024,
        isTablet: window?.innerWidth <= 768,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { login, logout, handleLoginClick, isLoginModalOpen, handleRegisterClick, isRegisterModalOpen, handleCloseModal } = useAuth();

  const handleLinkClick = (links) => setChildLinks(links || null);

  const handleLoginSuccess = (userData) => {
    login(userData);
  };

  const hideFooterRoutes = ["/live-casino", "/casino"];
  const hideFooter = hideFooterRoutes.some((route) => route === location.pathname.startsWith(route));

  return (
    <ErrorBoundary
      fallback={
        <div className="flex flex-col h-full w-full min-h-screen justify-center items-center">
          <pre className=" text-red-500 text-2xl">{t("errBoundaryMsg")}</pre>
          <small className="text-slate-500">{t("errBoundaryDesc")}</small>
        </div>
      }
    >
      <AppHeader
        childLinks={childLinks}
        onLinkClick={handleLinkClick}
        onLoginClick={handleLoginClick}
        onRegisterClick={handleRegisterClick}
        changeLanguage={changeLanguage}
        onLogout={logout}
      />
      <main className="bg-body relative">
        <Outlet />
      </main>
      {!hideFooter && <AppFooter />}
      {!isSportsbookPage && matchesMedia.isMobile && <Appbar onLinkClick={handleLinkClick} />}
      {isLoginModalOpen && (
        <Login onLoginSuccess={handleLoginSuccess} isOpen={isLoginModalOpen} onClose={handleCloseModal} handleRegisterClick={handleRegisterClick} />
      )}
      {isRegisterModalOpen && (
        <Register
          onRegisterSuccess={handleRegisterClick}
          isOpen={isRegisterModalOpen}
          onClose={handleCloseModal}
          handleLoginClick={handleLoginClick}
        />
      )}
    </ErrorBoundary>
  );
};

export default AppLayout;
